import type { OrgRole } from "@/lib/api";
import { Crown, ShieldCheck, User, Wallet } from "lucide-react";

export const ASSIGNABLE_ORG_ROLES: OrgRole[] = ["admin", "billing_admin", "member"];

export const ORG_ROLE_LABEL: Record<OrgRole, string> = {
  owner: "Owner",
  admin: "Admin",
  billing_admin: "Billing admin",
  member: "Read-only",
};

export const ORG_ROLE_ICON: Record<OrgRole, typeof Crown> = {
  owner: Crown,
  admin: ShieldCheck,
  billing_admin: Wallet,
  member: User,
};

export const ORG_ROLE_TAGLINE: Record<OrgRole, string> = {
  owner: "Full control of the org.",
  admin: "Manage people and Boos.",
  billing_admin: "Manage billing and get billing emails.",
  member: "Sees the org's Boos and who owns them. What they can do inside a Boo is set on that Boo.",
};

export const ORG_ROLE_PERMISSIONS: Record<OrgRole, string[]> = {
  owner: [
    "Full control of the organization",
    "Transfer ownership and delete the org",
    "Manage people & invitations (any role)",
    "Create, pause, and delete Boos, and take ownership of any Boo",
  ],
  admin: [
    "Invite and remove people (not the owner)",
    "Change roles below owner",
    "Create, pause, and resume Boos",
    "Cannot see inside a Boo without a role in it",
  ],
  billing_admin: [
    "View balance, spend, and transactions",
    "Buy credits and manage auto-recharge & spend caps",
    "Receive all billing emails for the org",
    "Cannot manage people, Boos, or settings",
  ],
  member: [
    "See every Boo and who owns it",
    "Own or work in a Boo at the level set on that Boo",
    "See their own spending limits",
    "Cannot create Boos, invite people, or change org settings",
  ],
};
